<template>
  <div
    class="sb-callout"
    v-if="key < 1 && vis == true"
    :key="key"
    v-show="!menuOpen && !recentOpen && !similarOpen"
  >
    <span class="sb-close" @click="hideCallOut"> &#10005; </span>
    <p>{{ text }}</p>
    <span class="arrow-down"></span>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      key: 1,
      vis: true,
    };
  },
  watch: {
    menuOpen(val) {
      if (val == true || this.recentOpen == true || this.menuOpen == true) {
        this.$store.commit("COMPLETE_TOUR", "dnd");

        this.vis = false;
      }
    },
    similarOpen(val) {
      if (val == true || this.recentOpen == true || this.menuOpen == true) {
        this.$store.commit("COMPLETE_TOUR", "dnd");

        this.vis = false;
      }
    },
    recentOpen(val) {
      if (val == true || this.similarOpen == true || this.menuOpen == true) {
        this.$store.commit("COMPLETE_TOUR", "dnd");

        this.vis = false;
      }
    },
  },
  computed: {
    ...mapState([
      "menuOpen",
      "similarOpen",
      "crosssellOpen",
      "recentOpen",
      "purchasedOpen",
      "ctaOpen",
      "dndEnabled",
      "client",
      "dndTourDone",
    ]),
    text() {
      if (
        window.location.host == "staging.interflora.dk" ||
        window.location.host == "interflora.dk"
      ) {
        return "Drag and drop forstørrelsesglasikonet over et produkt for at se lignende produkter.";
      } else if (window.location.host == "www.interflora.es") {
        return "Arrastre y suelte la lupa sobre un producto para ver productos similares";
      } else {
        return "Drag & drop the magnifier glass over a product to see similiar products.";
      }
    },
  },
  mounted() {
    setTimeout(() => {
      const isPanelShowing =
        this.crosssellOpen ||
        this.similarOpen ||
        this.recentOpen ||
        this.purchasedOpen ||
        this.ctaOpen
          ? true
          : false;

      if (this.dndTourDone == false && !isPanelShowing && this.key <= 1) {
        this.key = 0;
        setTimeout(() => {
          this.$store.commit("COMPLETE_TOUR", "dnd");
          this.key += 1;
        }, 12000);
      }
    }, 1000);
  },
  methods: {
    hideCallOut() {
      this.$store.commit("COMPLETE_TOUR", "dnd");

      this.vis = false;
    },
  },
};
</script>
<style scoped>
.sb-callout {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 8px 12px rgba(139, 129, 122, 0.012),
    0px 2px 8px rgba(0, 0, 0, 0.12);
  border-radius: 3px;
  padding: 8px !important;
  max-width: 232px;
  position: fixed;
  bottom: 70px;
  right: unset;
  left: 85px;
  z-index: 2147483642;
}
.arrow-down {
  width: 20px;
  height: 10px;
  position: absolute;
  top: 100%;
  overflow: hidden;
  left: 8px;
  right: unset;
}
.arrow-down:after {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  background: white;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  top: 0;
  left: 50%;
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.18);
}
.shopbox-right .sb-callout .arrow-down {
  left: unset;
  right: 8px;
}
.shopbox-right .sb-callout {
  right: 85px;
  left: unset;
}
.sb-close {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 24px;
  height: 24px;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2147483647;
  color: inherit;
  transition: all 200ms ease-out;
}
.sb-cta .sb-close {
  color: #000;
}
</style>